import React from 'react'
import Drawer from '../../../components/Drawer'
import Header from '../../../components/Header'
import { Container, Content } from './styles'

export interface PrivateProps {
  children: any
  title?: string
  fullPage?: boolean
}

type DrawerRef = React.ElementRef<typeof Drawer>

import Footer from '../../../components/Footer'

const Private: React.FunctionComponent<PrivateProps> = ({ children, title, fullPage }) => {
  const refDrawer = React.useRef<DrawerRef>(null)

  const handleModal = () => refDrawer.current?.handleModal()

  return (
    <Container fullPage={fullPage}>
      <Drawer ref={refDrawer} />
      <Header handleModal={handleModal} title={title} />
      <Content>{children}</Content>
      <Footer />
    </Container>
  )
}

export default Private
